<template>
  <div class="add-user-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive display-sub-title">
            <div class="modal-title" style="padding-left: 20px;">
              <h1>Request Additional User</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
            <div class="padding-left-20" style="padding-top: 30px;">
              Please provide the details of the required new user:
            </div>
          </div>
          <div class="modal-body div-responsive">
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">First Name</div>
                <div class="box-col box-col-right">
                  <input type="text" v-model="newUser.firstName"  placeholder="First Name" />
                  <div class="text-danger" v-if="hasError && validateFirstName">
                    {{ validateFirstName }}
                  </div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Surname</div>
                <div class="box-col box-col-right">
                  <input type="text" v-model="newUser.lastName"  placeholder="Surname" />
                  <div class="text-danger" v-if="hasError && validateLastName">
                    {{ validateLastName }}
                  </div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Email Address</div>
                <div class="box-col box-col-right">
                  <input type="text"  v-model="newUser.email"  placeholder="Email Address" />
                  <div class="text-danger" v-if="hasError && validateUserEmail">
                    {{ validateUserEmail }}
                  </div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Phone Number</div>
                <div class="box-col box-col-right">
                  <input type="text" @blur="normalizePhoneField" v-model="newUser.phoneNumber" placeholder="Phone Number" />
                  <div class="text-danger" v-if="hasError && validatePhone">
                    {{ validatePhone }}
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div class="alert alert-danger hidden-element">
                  <a class="close" title="close">×</a>
                  <b>Error:</b> Please correct the errors shown above and try again.
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn
                      class="white-button"
                      @click="handleModal($event)"
                      dark>Cancel</v-btn>
                    <v-btn
                      @click="clickSubmit"
                      dark>Submit</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import CitySuggestion from '@/components/CitySuggestion'

export default {
  name: "AddUserModal",
  components: {
    CitySuggestion,
  },
  data() {
    return {
      loadModal: false,
      hasError: false,
      clickState: false,
      newUser: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        lastLogin: '',
      },
    }
  },

  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    validateFirstName() {
      return utilities.getValidateNameTextError(this.newUser.firstName)
    },
    validateLastName() {
      return utilities.getValidateNameTextError(this.newUser.lastName)
    },
    validatePhone() {
      return utilities.getClientContactPhoneAu12Error(this.newUser.phoneNumber)
    },
    validateUserEmail() {
      if (!this.newUser.email) {
        return 'Email is required'
      } else if (this.newUser.email.length > 0 && !utilities.validateEmail(this.newUser.email)) {
        return 'Invalid email address'
      } else {
        return ''
      }
    },
  },

  methods: {
    normalizePhoneField() {
      this.newUser.phoneNumber = utilities.normalizeAuPhoneInput(this.newUser.phoneNumber)
    },
    handleModal(e) {
      this.loadModal = !this.loadModal
      if(this.loadModal) {
        $("html").addClass("modal-mask-open")
      } else {
        $("html").removeClass("modal-mask-open")
        this.hasError = false
      }
    },

    clickSubmit: async function () {
      if (this.validateFirstName || this.validateLastName || this.validateUserEmail || this.validatePhone) {
        this.hasError = true
        utilities.showAlert(".alert-danger")
        return
      }

      this.$store.dispatch("loading/setLoadComponent", true)
      var user = {
        FirstName: this.newUser.firstName,
        Surname: this.newUser.lastName,
        NewUserEmail: this.newUser.email,
        NewUserPhoneNumber: this.newUser.phoneNumber,
        ClientID: this.user.clientId,
        LogDate: window.moment().format('YYYY-MM-DD HH:mm:ss'),
        UserID: this.user.id,
        Username: this.user.name,
        ClientName: this.$parent.client.ClientName,
        BranchName: this.$parent.client.branchName,
      }
      var callback = (response) => {
        console.log('close it')
        this.handleModal()
        this.newUser.firstName = ""
        this.newUser.lastName = ""
        this.newUser.email = ""
        this.newUser.phoneNumber = ""
        this.$parent.displayMessage()

      }
      await utilities.postNewUser(user, callback)
      this.$store.dispatch("loading/setLoadComponent", false)
    },

    handleState() {
      this.clickState = true
    },
  },

  beforeMount() {},

  mounted() {},

  updated() {},
}
</script>
